export default __webpack_public_path__ + "static/media/IMG-20241005-WA0020.1883d448.jpg";